import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useForm } from "../../Hooks"
import { alertSuccess, createFormData, requestGet, requestPost } from "../../Helpers"
import { ContentShowMore, Image } from "../../Components"


export const RefundRequest = () => {

    const navigate = useNavigate()
    const { order_id } = useParams()
    const { formState, onInputChange } = useForm({})
    const [ refund, setRefund ] = useState([])

    useEffect(() => {
        if (order_id === null || order_id === undefined) {
            return navigate(-1)
        }
        handleGetStateRefundRequest()
        console.log(order_id)

    }, [order_id])


    const handleGetStateRefundRequest = () => {

        requestGet(`refund-requests/?order_id=${order_id}`)
            .then((res) => {
                console.log(res)
                if (res.results.length > 0) {
                    setRefund(res.results[0])
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    const handleSendRefundRequest = () => {

        const formData = createFormData({
            "subject": formState.subject,
            "reason": formState.reason,
            // "image": formState.image,
            "order_id": order_id,
        })

        // Aquí puedes enviar formData a tu API
        requestPost('refund-requests/', formData)
            .then((res) => {
                console.log(res)
                alertSuccess("Solicitud de reembolso enviada con éxito", "Estamos procesando tu solicitud, te notificaremos por correo electrónico cuando se haya procesado tu solicitud.")
            })
            .catch((err) => {
                console.log(err)
            })

    }
    
  
    return (
        <div className="row">

            <div className="col-md-12">
                <div className="bg-warning rounded rounded-3 p-3 ">
                    <h5 className="text-center text-white">Condiciones para el proceso de solicitud de reembolso</h5>
                    <ContentShowMore
                        text={
                            `<div>
                                <p className="text-white">Para solicitar un reembolso, debes cumplir con las siguientes condiciones:</p>
                                <ul className="text-white">
                                    <li>El producto debe estar en su estado original y sin usar.</li>
                                    <li>El producto debe ser devuelto en su embalaje original.</li>
                                    <li>El producto debe ser devuelto dentro de los 7 días posteriores a la compra.</li>
                                    <li>El producto no debe haber sido dañado o alterado de ninguna manera.</li>
                                    <li>El producto no debe haber sido utilizado.</li>
                                    <li>El producto no debe haber sido personalizado.</li>
                                    <li>El producto no debe haber sido comprado en oferta o en descuento.</li>
                                    <li>El producto no debe haber sido comprado en una venta final.</li>
                                    <li>El producto no debe haber sido comprado en una venta privada.</li>
                                    <li>El producto no debe haber sido comprado en una venta flash.</li>
                                    <li>El producto no debe haber sido comprado en una venta de liquidación.</li>
                                    <li>El producto no debe haber sido comprado en una venta de clearance.</li>
                                </ul>
                                <p className="text-white">Si cumples con todas estas condiciones, puedes solicitar un reembolso.</p>
                                <p className="text-white">Si tienes alguna duda, no dudes en contactarnos.</p>
                                <p className="text-white">Gracias por tu comprensión.</p>
                            <div/>`
                        }
                    />
                </div>
            </div>

            <hr className="my-4" />

            {
                refund?.status_refund === "requested" ?
                    <div className="col-md-12">
                        <div className="alert alert-warning" role="alert">
                            Ya has solicitado un reembolso para este pedido, estamos procesando tu solicitud.
                        </div>
                    </div>
                : refund?.status_refund === "approved" ?
                    <div className="col-md-12 text-center">
                        <div className="alert alert-success" role="alert">
                            Tu solicitud de reembolso ha sido aceptada, estamos procesando tu solicitud.
                            <p className="text-success p-0 m-0">Recibiras tu dinero por el medio por el cual fue solicitado.</p>
                            <p className="text-success p-0 m-0">Gracias por tu comprensión.</p>
                        </div>
                    </div>
                : refund?.status_refund === "denied" ?
                    <div className="col-md-12">
                        <div className="alert alert-danger" role="alert">
                            Tu solicitud de reembolso ha sido rechazada, por favor contacta con el servicio al cliente.
                        </div>
                    </div>
                :
                    <div className="col-md-12">
                        <div className="alert alert-info" role="alert">
                            Puedes solicitar un reembolso para este pedido.
                        </div>
                    </div>
            }

            <hr className="my-4" />

            <div className="col-md-12">
                <div className="w-75 m-auto card p-0" >
                    <div className="card-header">
                        <h5 className="card-title">Detalles de la compra</h5>
                    </div>
                    <div className="row p-3">
                        <div className="col-md-6">
                            <Image src={"../../assets/img/recibo.png"} alt="Recibo" className="img-fluid" />
                        </div>
                        <div className="col-md-6">
                            <div className="">
                                <h5 className="card-title">Detalles de la compra</h5>
                                <p className="card-text">Número de orden: {order_id}</p>
                                <p className="card-text">Número de venta: {order_id}</p>
                                <p className="card-text">Fecha de compra: {new Date().toLocaleDateString()}</p>
                                <p className="card-text">Total: $0.00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr className="my-4" />

            <div className="col-md-10 m-auto">
                <div className="card p-0" >
                    <div className="card-header">
                        <h5 className="card-title">
                            Proceso de reembolso
                        </h5>
                    </div>
                    <div className="card-body">
                        <form className="row p-3">
                            <div className="col-12 w-75 m-auto">
                                <div className="form-group ">
                                    <small className="form-text text-muted">Escribe el asunto</small>
                                    <input disabled={refund?.subject} defaultValue={refund?.subject} name="subject" type="text" className="form-control" placeholder="Asunto" onChange={onInputChange} />
                                </div>
                                <div className="form-group mb-3">
                                    <small className="form-text text-muted">Escribe con detalle el motivo de tu reembolso</small>
                                    <textarea disabled={refund.reason}  onChange={onInputChange} defaultValue={refund?.reason} name="reason" className="form-control" rows="3" placeholder="Descripción"></textarea>
                                </div>
                                {/* <div className="form-group mb-3">
                                    <small className="form-text text-muted">Adjunta una imagen</small>
                                    <input type="file" className="form-control" />
                                </div> */}
                            </div>
                            <div className="col-12">
                                <div className="d-flex justify-content-around mt-3">
                                    <button disabled={refund.reason}  type="button" className="btn btn-primary" onClick={handleSendRefundRequest}>Enviar</button>
                                    <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>Volver</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="card-footer">
                        <p className="card-text p-0 m-0">Recibirás un correo electrónico con el estado de tu solicitud</p>
                        <p className="card-text p-0 m-0">Si tienes alguna duda, no dudes en contactarnos</p>
                        <p className="card-text p-0 m-0">Gracias por tu comprensión</p>
                    </div>
                </div>
            </div>

        </div>
    )
}
